import { createSelector } from '@ngxs/store';

import { CourseListState } from './course-list.state';
import { CourseListProjectPostStateModel } from './course-list.model';
import { ProjectPost } from '@frontend/unhideschool/shared/models/project/project-post.model';

export class CourseListSelectors {
  static getCourseListPageProjects() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.projectposts;
      }
    );
  }

    static getCourseListProjectPost() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost;
      }
    );
  }

  static getCourseListPageProjectsFiltered(filtervalue) {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.projectposts.filter(
          (project: ProjectPost) => project.title === filtervalue
        );
      }
    );
  }

  static getPagination() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.pagination;
      }
    );
  }

  static getPostLimit() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.postLimit;
      }
    );
  }

  static getIsNotFound() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.notfound;
      }
    );
  }

  static getCourseListPageProjectsFilteredWithInput(filtervalue: string) {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.projectposts.filter(
          (project: ProjectPost) =>
            project.title.toLowerCase().includes(filtervalue.toLowerCase())
        );
      }
    );
  }

  static getLowerPriceCourseData() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.lowerPriceCourseData;
      }
    );
  }

  static getLowerPriceCareerData() {
    return createSelector(
      [CourseListState],
      (courseListProjectPost: CourseListProjectPostStateModel) => {
        return courseListProjectPost.lowerPriceCareerData;
      }
    );
  }
}
